export default __webpack_public_path__ + "static/media/remittanceImg.cc95bf30.png";